import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { ProjectsComponent } from "./projects/projects.component";
import { ModelComponent } from "./projects/project/model/model.component";
import { DataComponent } from "./projects/project/data/data.component";
import { CostsComponent } from "./projects/project/costs/costs.component";
import { CallbackComponent } from "./callback/callback.component";

import { AuthGuardService } from "./shared/services/auth-guard.service";

import { PlotsComponent } from "./projects/project/plots/plots.component";
import { ShotImageComponent } from "./projects/project/shot-image/shot-image.component";
import { RunfileComponent } from "./projects/project/runfile/runfile.component";
import { FilesComponent } from "./projects/project/files/files.component";

import { ScreenshotComponent } from "./projects/project/screenshot/screenshot.component";
import { TablesComponent } from "./projects/project/tables/tables.component";
import { EnvVarsComponent } from "./projects/project/env-vars/env-vars.component";
import { EnvVarsComponent as ProjectViewEnvVarsComponent } from "./projects/project-view/env-vars/env-vars.component";
import { FlowchartComponent } from "./projects/project-view/flowchart/flowchart.component";
import { ImagePanelComponent } from "./projects/project-view/image-panel/image-panel.component";
import { ProjectViewComponent } from "./projects/project-view/project-view.component";
import { DataTableComponent } from "./projects/project-view/data-table/data-table.component";
import { ModelTableComponent } from "./projects/project-view/model-table/model-table.component";
import { Flowchart2Component } from "./projects/project-view/flowchart2/flowchart2.component";
import { StorageTableComponent } from "./projects/project-view/storage-table/storage-table.component";
import { JobGroupsComponent } from "./projects/project-view/job-groups/job-groups.component";
import { TraceFitsPlottingComponent } from "./projects/project-view/trace-fits-plotting/trace-fits-plotting.component";
import { ProjectDashboardComponent } from "./projects/project-view/project-dashboard/project-dashboard.component";
import { ParameterOverviewComponent } from "./projects/project-view/parameter-overview/parameter-overview.component";
import { ModelVisualizerComponent } from "./projects/project-view/model-visualizer/model-visualizer.component";
import { JobOuputRouteComponent } from "./job-ouput-route/job-ouput-route.component";
import { ContactAdminComponent } from "./contact-admin/contact-admin.component";
import { JobSubmissionComponent } from "./projects/project-view/job-submission/job-submission.component";
import { ProjectNewComponent } from "./projects/project/project-new/project-new.component";
import { ModelNewComponent } from "./projects/project/model-new/model-new.component";
import { SegyViewerComponent } from "./projects/project/segy/segy-viewer/segy-viewer.component";
import { GeneralInformationComponent } from "./jobs/general-information/general-information.component";
import privateRoutes from "./private-routes";

const routes: Routes = [
  { path: "login", component: LoginComponent, pathMatch: "full" },
  { path: "unauthorised", redirectTo: "/login", pathMatch: "full" },
  { path: "", redirectTo: "/projects", pathMatch: "full" },
  { path: "callback", component: CallbackComponent },
  ...privateRoutes as any,
  {
    path: "projects",
    component: ProjectsComponent,
    pathMatch: "full",
    canActivate: [AuthGuardService],
  },
  {
    path: "job",
    component: JobOuputRouteComponent,
    pathMatch: "full",
    canActivate: [AuthGuardService],
  },
  {
    // Standalone single SEG-Y file viewer (no project / prep run required)
    path: "segy",
    component: SegyViewerComponent,
    pathMatch: "full",
    canActivate: [AuthGuardService],
  },
  {
    path: "projects/:id",
    component: ProjectNewComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: "",
        redirectTo: "model",
        pathMatch: "full",
      },
      // {
      //   path: "model-old",
      //   component: ModelComponent,
      // },
      {
        path: "model",
        component: ModelNewComponent,
      },
      {
        path: "job",
        component: GeneralInformationComponent,
      },
      {
        path: "costs",
        component: CostsComponent,
      },
      {
        path: "charts",
        component: PlotsComponent,
      },
      {
        path: "shots",
        component: ShotImageComponent,
      },
      {
        path: "runfile",
        component: RunfileComponent,
      },
      {
        path: "picture",
        component: ScreenshotComponent,
      },
      {
        path: "files",
        component: FilesComponent,
      },
      {
        path: "tables",
        component: TablesComponent,
      },
      {
        path: "env_vars",
        component: EnvVarsComponent,
      },
      // { path: "log", component: LogComponent },
    ],
  },
  {
    path: "contact-admin",
    component: ContactAdminComponent,
  },
  {
    path: "project/:id",
    canActivate: [AuthGuardService],
    component: ProjectViewComponent,
    children: [
      {
        path: "",
        // component: ProjectDashboardComponent,
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        component: ProjectDashboardComponent,
      },
      {
        path: "table",
        component: StorageTableComponent,
      },
      {
        path: "model-compare",
        component: ModelVisualizerComponent,
      },
      {
        path: "parameter-view",
        component: ParameterOverviewComponent,
      },
      {
        path: "env-vars",
        component: ProjectViewEnvVarsComponent,
      },
      {
        path: "trace-fits-plotting",
        component: TraceFitsPlottingComponent,
      },
      {
        path: "job-groups",
        component: JobGroupsComponent,
      },
      {
        path: "data-table",
        component: DataTableComponent,
      },
      {
        path: "data-table/:trace_locator",
        component: DataTableComponent,
      },
      {
        path: "model-table",
        component: ModelTableComponent,
      },
      {
        path: "flowchart",
        component: FlowchartComponent,
      },
      {
        path: "flowchart2",
        component: Flowchart2Component,
      },
      {
        path: "image-panel",
        component: ImagePanelComponent,
      },
      {
        path: "job-submission",
        component: JobSubmissionComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
